{
  "version": 1,
  "asset_id": "2bc960ce-cf0a-4e45-88b5-d751840fb854",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/2bc960ce-cf0a-4e45-88b5-d751840fb854/clip-img_2370.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/2bc960ce-cf0a-4e45-88b5-d751840fb854/clip-img_2370.mp4",
  "original_filename": "clip-img_2370.mp4",
  "size": 365656,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:33:13Z"
}
